"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function warn(msg) {
    console.warn("[Vue3-lazy warn]: " + msg);
}
exports.warn = warn;
//# sourceMappingURL=debug.js.map